import * as Ion from '@ionic/react';
import React from 'react';

import { IonButtons } from '@ionic/react';

/*
	Usage:
	<Page largeTitle padding menu>
		<p>content here</p>
  </Page>
  
  Props: 
    - menu
    - renderButtonsRight
    - renderDirectChildren
*/

const Page = (props) => {
  return (
    <Ion.IonPage>
      <Ion.IonContent
        color={props.contentColor}
        fullscreen="true"
        forceOverscroll={false}
      >
        <div style={{ padding: props.padding && 16 }}>{props.children}</div>

        {props.renderDirectChildren && props.renderDirectChildren()}
      </Ion.IonContent>
    </Ion.IonPage>
  );
};

export default Page;
